export default __webpack_public_path__ + "static/media/jap-ecommerceImg_7.aca4deb5.png";